// Supporter Service Fee — Model A (Sep 25, 2026, Randy).
//
// ONE calculator for the whole frontend. The creator's amount is what the
// creator RECEIVES; the supporter pays that plus this fee, which covers the
// platform's revenue share and the cost of processing:
//
//   F = ceil( (A·(r + s) + f·10000) / (10000 − s) )
//
// Grossing up by 1/(1−s) is not optional — Stripe charges its percentage on
// the fee as well as on the creator's amount. Integer-only and rounded UP,
// byte-for-byte the same arithmetic as `supporter_service_fee_cents` in
// backend/stripe_module.py. This is a DISPLAY mirror: every charge is priced
// by the server, which recomputes the fee and ignores anything sent from here.

export const SUPPORTER_FEE_DEFAULTS = {
  revenue_bps: 500,     // platform revenue share (fan_cut_bps)
  processing_bps: 290,  // Stripe's percentage — estimate
  fixed_cents: 30,      // Stripe's per-charge fixed cost — estimate
};

export function feeConfigFromSilo(silo) {
  return {
    revenue_bps: silo?.supporter_fee_revenue_bps ?? SUPPORTER_FEE_DEFAULTS.revenue_bps,
    processing_bps: silo?.supporter_fee_processing_bps ?? SUPPORTER_FEE_DEFAULTS.processing_bps,
    fixed_cents: silo?.supporter_fee_fixed_cents ?? SUPPORTER_FEE_DEFAULTS.fixed_cents,
  };
}

export function supporterFeeCents(amountCents, cfg = SUPPORTER_FEE_DEFAULTS) {
  const amount = Math.round(Number(amountCents) || 0);
  if (amount <= 0) return 0;
  const s = cfg.processing_bps ?? SUPPORTER_FEE_DEFAULTS.processing_bps;
  const r = cfg.revenue_bps ?? SUPPORTER_FEE_DEFAULTS.revenue_bps;
  const f = cfg.fixed_cents ?? SUPPORTER_FEE_DEFAULTS.fixed_cents;
  const den = 10000 - s;
  if (den <= 0) return 0;
  return Math.ceil((amount * (r + s) + f * 10000) / den);
}

export const money = (cents) => `$${((Number(cents) || 0) / 100).toFixed(2)}`;
